import {
	Calendar,
	CalendarCell,
	CalendarHeaderTitleProps,
	CalendarProps,
	CalendarWeekCell,
	CalendarWeekCellProps,
	DatePicker,
	DatePickerProps,
	DateTimePicker,
	DateTimePickerProps,
	MultiViewCalendar,
	MultiViewCalendarProps,
} from "@progress/kendo-react-dateinputs";
import { format } from "date-fns";
import { t } from "i18next";
import { FC, useRef, useState, useEffect } from "react";
import "./date.css"; // Import the CSS file
import {
	IntlProvider,
	LocalizationProvider,
	load,
	loadMessages,
} from "@progress/kendo-react-intl";
import i18n from "i18n";

// import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
// import currencyData from "cldr-core/supplemental/currencyData.json";
// import weekData from "cldr-core/supplemental/weekData.json";
// // import numbers from "cldr-numbers-full/main/no/numbers.json";
// import caGregorian from "cldr-dates-full/main/no/ca-gregorian.json";
// import dateFields from "cldr-dates-full/main/no/dateFields.json";

// Load CLDR data

// Load localized messages
loadMessages(
	{
		calendar: {
			today: t("Today"),
		},
		datetimepicker: {
			time: t("Time"),
			date: t("Date"),
			cancel: t("Cancel"),
			set: t("Ok"),
		},
		timepicker: {
			now: t("Now"),
		},
	},
	"auto"
); // Load your custom messages

//export function CustomDateInput(props: FieldRenderProps & DateInputProps) {
//  return (
//      <DateInput

//          {...props}
//      />
//  );
//}

// docs https://date-fns.org/v3.6.0/docs/format

export const GrideDateFormatter: FC<{
	date: string | Date;
	formatType?: string;
	style?: React.CSSProperties;
	noTd?: boolean;
}> = ({ date, formatType = "dd.MM.yyyy", style, noTd = false }) => {
	if (!date || date === undefined) {
		if (noTd) {
			return null;
		}
		// shows loading cell if no data
		return (
			<td style={{ border: "none", ...style }}>
				{/* <Skeleton
					shape={"text"}
					style={{
						width: "100%",
					}}
				/> */}
			</td>
		);
	}

	const result = format(new Date(date), formatType);
	if (noTd) {
		return <span style={{ border: "none", ...style }}>{result}</span>;
	}

	return <td style={{ border: "none" }}>{result}</td>;
};

export const generateYearList = (fromYear: number) => {
	const currentYear = new Date().getFullYear();
	const yearList = [];
	for (let i = fromYear; i <= currentYear; i++) {
		yearList.push(i);
	}
	return yearList;
};

const DateCalendarHeader = (props: CalendarHeaderTitleProps) => {
	let text = props.children as string;
	if (!text) {
		text = props.value as string;
	}
	const values = text.split(" ");
	const year = values[1];
	const month = values[0];
	const value = `${t(month)} ${year}`;
	return (
		<div {...props} className="date-calendar-header">
			{value}
		</div>
	);
};

const DatePickerComponent = (props: DatePickerProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const datePickerRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const modifyWeekdayHeaders = () => {
			if (!datePickerRef.current) return;

			const calendarHeaders = document.querySelectorAll(
				".k-calendar-thead .k-calendar-th"
			);

			calendarHeaders.forEach((header, index) => {
				const dayName = t(header.innerHTML);
				header.innerHTML = dayName;
			});
		};

		// modifyWeekdayHeaders();
	}, [isOpen, datePickerRef.current]);
	// const state = { locale: "no-NO", value: new Date() };

	return (
		<LocalizationProvider language={"auto"}>
			<div ref={datePickerRef}>
				<DatePicker
					// show={true}

					// onOpen={() => setIsOpen(true)}
					// onClose={() => setIsOpen(false)}

					calendar={(props: MultiViewCalendarProps) => (
						<MultiViewCalendar
							{...props}
							// headerTitle={DateCalendarHeader}
							views={1}
						/>
					)}
					defaultShow={props.defaultShow}
					{...props}
				/>
			</div>
		</LocalizationProvider>
	);
};

export const DateTimePickerComponent = (props: DateTimePickerProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [dateToggled, setDateToggled] = useState(false);
	const [timeUpdatedAlready, setTimeUpdatedAlready] = useState(false);
	const datePickerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		let calendarHeaders: NodeListOf<Element> | null = null;

		// const modifyWeekdayHeaders = () => {
		// 	if (calendarHeaders && calendarHeaders.length > 0) return;

		// 	const timeNodes = document.querySelectorAll(
		// 		".k-time-list-wrapper .k-title"
		// 	);

		// 	if (!timeUpdatedAlready) {
		// 		timeNodes.forEach((node) => {
		// 			const timeText = node.innerHTML;
		// 			const capitalizedText =
		// 				timeText.charAt(0).toUpperCase() + timeText.slice(1);
		// 			const translatedText = t(capitalizedText);
		// 			node.innerHTML = translatedText;
		// 		});
		// 	}

		// 	if (timeNodes.length > 0 && !timeUpdatedAlready) {
		// 		setTimeUpdatedAlready(true);
		// 	}

		// 	calendarHeaders = document.querySelectorAll("th.k-calendar-th");

		// 	if (calendarHeaders && calendarHeaders.length > 0) {
		// 		calendarHeaders.forEach((header, index) => {
		// 			const dayName = t(header.innerHTML);
		// 			header.innerHTML = dayName;
		// 		});
		// 	}
		// };

		const attempts = [50, 100];
		attempts.forEach((delay, i) => {
			setTimeout(() => {
				// if (calendarHeaders) return;
				// modifyWeekdayHeaders();
			}, delay);
		});

		return () => {};
	}, [isOpen, dateToggled, datePickerRef]);

	useEffect(() => {
		if (!isOpen) return;
		let buttonGroup = document.querySelector(".k-datetime-buttongroup");
		const handler = () => {
			buttonGroup = document.querySelector(".k-datetime-buttongroup");
			if (buttonGroup) {
				buttonGroup.addEventListener("click", (e) => {
					setDateToggled((prev) => !prev);
				});
			}
		};

		if (!buttonGroup) {
			const attempts = [50, 100];
			attempts.forEach((delay, i) => {
				if (buttonGroup) return;
				setTimeout(() => {
					handler();
				}, delay);
			});
		} else {
			handler();
		}

		return () => {
			buttonGroup?.removeEventListener("click", (e) => {});
		};
	}, [isOpen, datePickerRef]);

	return (
		<LocalizationProvider language="auto">
			<DateTimePicker
				// show={true}
				ref={datePickerRef}
				// onOpen={() => setIsOpen(true)}
				// onClose={() => setIsOpen(false)}
				calendar={(props: CalendarProps) => (
					<Calendar
						{...props}
						// headerTitle={DateCalendarHeader}
						// weekCell={CustomWeekCell}

						// headerTitle={(props) => {
						// 	console.log("headerTitle", props);

						// 	return <div>dh</div>;
						// }}
					/>
				)}
				{...props}
			/>
		</LocalizationProvider>
	);
};

export default DatePickerComponent;

export const CustomWeekCell = (props: CalendarWeekCellProps) => {
	const firstDate = props.firstDate;
	firstDate.setDate(1);
	return (
		<CalendarWeekCell {...props} firstDate={firstDate}>
			{props.value}
		</CalendarWeekCell>
	);
};
